// extracted by mini-css-extract-plugin
module.exports = {"postManage":"styles_postManage__2XtBC"};